import React from 'react';

const CreateCompanyConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false,
                },
                toolbar: {
                    display: false,
                },
                footer: {
                    display: false,
                },
                leftSidePanel: {
                    display: false,
                },
                rightSidePanel: {
                    display: false,
                },
            },
        },
    },
    routes: [
        {
            path: '/create-company',
            component: React.lazy(() => import('./CreateCompany')),
        },
    ],
};

export default CreateCompanyConfig;
